(function(){
var KEY='volicesWatchSelector:v1';
function load(){try{var x=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(x)?x:[]}catch(e){return[]}}
function pathname(h){try{return new URL(h,location.origin).pathname}catch(e){return h||''}}
function decorate(){
  if(!(window.matchMedia?window.matchMedia('(max-width: 749px)').matches:window.innerWidth<=749))return;
  var items=load();
  document.querySelectorAll('.vws-mobile-card').forEach(function(card){
    var price=card.querySelector('strong');
    if(!price)return;
    if(!price.classList.contains('vws-mobile-card__price'))price.classList.add('vws-mobile-card__price');
    if(card.querySelector('[data-vws-mobile-cart]'))return;
    var productLink=card.querySelector('.vws-mobile-card__link');
    if(!productLink)return;
    var path=pathname(productLink.getAttribute('href'));
    var item=items.find(function(i){return pathname(i.url)===path});
    if(!item||!item.variantId)return;
    var a=document.createElement('a');
    a.className='vws-mobile-card__cart-link';
    a.setAttribute('data-vws-mobile-cart','');
    a.textContent='ADD TO CART';
    a.href='/cart/'+encodeURIComponent(item.variantId)+':1';
    a.setAttribute('aria-label','Add '+(item.title||'watch')+' to cart');
    price.insertAdjacentElement('afterend',a);
  });
}
new MutationObserver(decorate).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('volices:watch-selector',decorate);
window.addEventListener('resize',decorate);
decorate();
})();